import React from 'react';
import { createMedsStep, medsCreateState } from 'store/storeValtio';

export default function MedicationWeekly({ prevStep, nextStep }) {
  //console.log('MedicationWeekly');

  function handleClick(days) {
    //console.log('handleClick', days);
    //const hr = days > 1 ? ' days' : ' day';
    //const often = `Every ${days}${hr}`;
    medsCreateState.often = 'weekly';
    medsCreateState.occurance = days;
    medsCreateState.schedule = [];
    nextStep(createMedsStep.weekdays);
  }

  const days = [];
  for (let i = 1; i < 7; ++i) {
    const hr = i > 1 ? ' days' : ' day';
    let cn = 'rawBtn w-full h-8 p-0 border-2 border-gray-400 text-sm text-blue';
    cn += (i === medsCreateState.occurance) ? " bg-green-300" : " bg-blue-300" ;
    days.push(
      <li key={i} className={'snap-start scroll-m-0 p-0 m-0'}>
        <button
          onClick={()=>handleClick(i)}
          className={cn}
        >
          {i}{hr}
        </button>
      </li>
    );
  }

  return (
    <div className='flex flex-col'>
      <div className='medBody text-center'>
        How many days per week do you take you medication?
      </div>
      <div className='mcard'>
        <div className='px-4 flex justify-center'>
          <ul className='w-96 h-[288px] snap-y snap-mandatory overflow-x-hidden overflow-y-scroll'>
              {days}
          </ul>
        </div>
      </div>
    </div>
  );
}
